import Vue from "vue";
import VueAnalytics from "vue-analytics";
import App from "./App";
import router from "./router";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronLeft,
  faChevronRight,
  faCheck,
  faQuoteRight,
  faQuoteLeft
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookSquare,
  faInstagramSquare
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faCheck);
library.add(faQuoteLeft);
library.add(faQuoteRight);
library.add(faFacebookSquare);
library.add(faInstagramSquare);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueAnalytics, {
  id: "UA-130957120-1",
  router
});

/* eslint-disable no-new */
const _vue = new Vue({
  el: "#app",
  router,
  render: h => h(App)
});

window._vuePrerender = _vue;



// WEBPACK FOOTER //
// ./src/main.js